module.exports = __webpack_public_path__ + "img/arrow-back.98332308.svg";